export default function formatPhoneWithDash(phoneNumber: string) {
  let formattedPhoneNumber = phoneNumber.replace(/\D/g, '');

  if (formattedPhoneNumber[0] === '1') {
    formattedPhoneNumber = formattedPhoneNumber.slice(1);
  }
  return formattedPhoneNumber.replace(/^(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
}
